﻿import numberingSystems from '@syncfusion/ej2-cldr-data/supplemental/numberingSystems.json';
import it from '@syncfusion/ej2-cldr-data/main/it/all.json';
import en from '@syncfusion/ej2-cldr-data/main/en/all.json';
import es from '@syncfusion/ej2-cldr-data/main/es/all.json';

declare const ej: any;

declare global {
  interface Window {
    loadCultureFiles: () => void;
  }
}

const cultures = { it, en, es };

ej.base.loadCldr(numberingSystems);

window.loadCultureFiles = function () {
  Object.values(cultures).forEach(function (culture) {
    ej.base.loadCldr(culture);
  });
};